"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var empty = exports.empty = {
    closed: true,
    next: function next(value) {},
    error: function error(err) {
        throw err;
    },
    complete: function complete() {}
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/rxjs/static-5.4/Observer.js
// module id = 153
// module chunks = 177